module.exports = __webpack_public_path__ + "static/media/api.fc9c48c2.svg";